module.exports = __webpack_public_path__ + "img/open-24--hours.c851c013.svg";